import { init, browserTracingIntegration, captureException, setExtra, withScope, setUser } from '@sentry/browser';
import * as version from '../version.json';



function getDSN() {
    let url = location.href;

    let dsn = "";

    // website
    if (/^(http|https):\/\/(pre|www)\.x\-legend\.com\/member/.test(url)) {
        dsn = "https://4e4df64f80f8a266ab5e61a429264db1@sentry.x-legend.com/3";
    } else {
        dsn = "https://0a65106bba8368e6a92d5b425830c9f2@sentry.x-legend.com/6";
    }
    return dsn;
}

init({
    dsn: getDSN(),

    // Alternatively, use `process.env.npm_package_version` for a dynamic release version
    // if your build tool supports it.
    release: "mapi@" + version['version'],
    integrations: [
        browserTracingIntegration(),
    ],

    // Set tracesSampleRate to 1.0 to capture 100%
    // of transactions for performance monitoring.
    // We recommend adjusting this value in production
    tracesSampleRate: 1.0,
});


export default { captureException, setExtra, withScope, setUser }; 